export const IS_NEW_USER_FLAG = 'isNewUser'
export const IS_MIXTILES_PLUS_PURCHASE_REFRESH = 'isMixtilesPlusPurchaseRefresh'
export const ONE_DAY_IN_MILLISECONDS = 86400000
